import { render, staticRenderFns } from "./ProblemasMaisAtendidos.vue?vue&type=template&id=462225a9&scoped=true&"
import script from "./ProblemasMaisAtendidos.vue?vue&type=script&lang=js&"
export * from "./ProblemasMaisAtendidos.vue?vue&type=script&lang=js&"
import style0 from "./ProblemasMaisAtendidos.vue?vue&type=style&index=0&id=462225a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462225a9",
  null
  
)

export default component.exports